<template>
  <div>
    <b-navbar type="dark" variant="primary" style="height : 6ex;" class="p-2" v-touch:swipe="swipeApp" v-touch:touchhold="togglePresentationMode">

      <router-link :to="{ name: 'tinkHome'}" custom v-slot="{ navigate }">
        <b-navbar-brand @click="navigate" @keypress.enter="navigate" role="link" class="cursor-pointer mt-1 ml-0" name="top" id="top">data.tinkable.net<sup>&beta;</sup></b-navbar-brand>
      </router-link>

      <b-navbar-nav class="ml-auto cursor-pointer">

        <div v-if="loginUser" class="langSelectButton">
            <b-img :src="onestopImgSrc" class="p-0 m-0 mr-2 avatarIcon rounded-circle bg-success-lighter border border-blue-lighter" alt="" v-b-tooltip.hover.left title="기기 등록 및 설정 도우미" @click="startOneStopAddDevice"/>
        </div> 

        <b-dropdown toggle-class="langSelectButton" toggle-tag="div" no-caret id="langSelectDropdown" class="m-0 p-0 border-0" variant="primary" menu-class="langSelectMenu">

          <template #button-content class="m-0 p-0 border-0">

            <b-img :src="langs[langIndex[selectedLang]].src" id="langSelect" class="p-0 m-0 mr-2 avatarIcon rounded-circle bg-light border border-light" :alt="langs[langIndex[selectedLang]].alt" data-toggle="dropdown" v-b-tooltip.hover.bottom :title="langs[langIndex[selectedLang]].title"/>

          </template>

          <b-dropdown-item v-for="lang in langs" class="langSelectMenuItem" :key="`${lang.name}SelectMenuItem`" :hidden="lang.name == selectedLang"><b-img :src="lang.src" class="p-0 m-0 mr-2 avatarIcon rounded-circle bg-light border border-light" :alt="lang.alt" tabindex="-1" v-b-tooltip.hover.left :title="lang.title" @click="changeLang(lang.name)"/></b-dropdown-item>

        </b-dropdown>

        <div v-if="loginUser">

          <b-avatar button v-if="loginUser.photoURL && this.loginUserFrReqArray.length != 0" id="myPhoto" :src="loginUser.photoURL" accesskey="m" variant="light" class="avatarIcon" v-b-toggle.myMenu v-b-tooltip.hover title="내 정보 보기" :badge="`${loginUserFrReqArray.length}`" badge-variant="danger"/>

          <b-avatar button v-else-if="loginUser.photoURL && this.loginUserFrReqArray.length == 0" id="myPhoto" :src="loginUser.photoURL" accesskey="m" variant="light" class="avatarIcon" v-b-toggle.myMenu v-b-tooltip.hover title="내 정보 보기"/>

          <b-avatar button v-else-if="this.loginUserFrReqArray.length != 0" id="myPhoto" variant="light" accesskey="m" class="avatarIcon" v-b-toggle.myMenu :badge="`${loginUserFrReqArray.length}`" badge-variant="danger" v-b-tooltip.hover title="내 정보 보기" />

          <b-avatar button v-else id="myPhoto" variant="light" accesskey="m" class="avatarIcon" v-b-toggle.myMenu v-b-tooltip.hover title="내 정보 보기"/>

        </div>
        <div v-else class="ml-auto">
          <b-avatar button id="myPhoto" v-b-modal.loginFloat accesskey="m" class="avatarIcon" :disabled="loginDisabled" :variant="(this.loginDisabled)? 'secondary' : 'light'"/>
        </div>
      </b-navbar-nav>
    </b-navbar>

    <b-sidebar v-touch:swipe.stop id="myMenu" shadow :lazy="true" :right="true" :no-header="true" :backdrop="true" width="320px" v-if="loginUser" v-model="myMenuShow" body-class="sidebarMyMenu">

      <h3 class="text-center font-weight-bold">
        {{$t("tHeader.myInfo")}}
      </h3>

      <b-media class="m-2 myMedia">
        <template #aside>

          <router-link v-if="loginUser.photoURL && loginUserFrReqArray.length != 0" :to="{ name: 'tinkUser', params: { uid: loginUser.id, mode: 'list' } }" custom v-slot="{ navigate }">
            <b-avatar @click="navigate" @keypress.enter="navigate" role="link" button :src="loginUser.photoURL" id="myPhotoBig" class="mr-0 mt-3 ml-1 cursor-pointer" :badge="`${loginUserFrReqArray.length}`" badge-variant="danger" v-b-tooltip title="나의 기기 목록 보기"/>
          </router-link>

          <router-link v-else-if="loginUser.photoURL" :to="{ name: 'tinkUser', params: { uid: loginUser.id, mode: 'list' } }" custom v-slot="{ navigate }">
            <b-avatar @click="navigate" @keypress.enter="navigate" role="link" button :src="loginUser.photoURL" id="myPhotoBig" class="mr-0 mt-3 ml-1 cursor-pointer" :badge="`${loginUserFrReqArray.length}`" badge-variant="danger" v-b-tooltip title="나의 기기 목록 보기"/>
          </router-link>

          <router-link v-else :to="{ name: 'tinkUser', params: { uid: loginUser.id, mode: 'list' } }" custom v-slot="{ navigate }">
            <b-avatar @click="navigate" @keypress.enter="navigate" role="link" button id="myPhotoBig" class="mr-0 mt-3 ml-1 cursor-pointer" :badge="`${loginUserFrReqArray.length}`" badge-variant="danger" v-b-tooltip title="나의 기기 목록 보기"/>
          </router-link>

        </template>
        <b-list-group>
          <b-list-group-item variant="primary" class="font-weight-bold" style="padding: 0.1rem 0.1rem 0.1rem 0.5rem">
            <big>
              <router-link :to="{ name: 'tinkUser', params: { uid: loginUser.id, mode: 'list' } }" v-b-tooltip title="나의 기기 목록 보기" custom v-slot="{ navigate }">
                <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">{{loginUser.displayName}}</span>
              </router-link>
            </big>
          </b-list-group-item>
          <b-list-group-item class="p-1 cursor-pointer fontSizeDot8" v-b-tooltip :title="$t('common.copyToClipboard')" @click="copyToClipboard">
            {{loginUser.id}}
          </b-list-group-item>
          <b-list-group-item class="p-1 fontSizeDot9">
            <a :href="`mailto:${loginUser.email}`">{{loginUser.email}}</a>
          </b-list-group-item>
          <b-list-group-item class="p-1" v-if="!loginUser.emailVerified">
            <b-button size="sm" variant="secondary" class="p-1" @click="sendConfirmMail">
              {{ $t("common.receiveConfirmMail") }}
            </b-button>
          </b-list-group-item>
        </b-list-group>
      </b-media>

      <div class="accordion" role="tablist">
        <div>
          <div class="p-0 mr-2 ml-2 border">

            <h4 role="tab" v-b-toggle.configuration variant="light" class="m-0 p-2 font-weight-bold cursor-pointer fontSize1Dot1">
              {{ $t("common.preference") }}
            </h4>

          </div>
          <b-collapse id="configuration" visible accordion="menuAccordion" role="tabpanel" class="m-0 p-0">
            <b-list-group squared class="mt-0 mr-2 ml-2 mb-0 border-top-0 rounded-0">

              <b-list-group-item v-if="isLoginUserAdmin" class="m-0 pl-3 pr-3 border-top-0" style="padding-top: 0.2rem; padding-bottom:0.1rem">
                <router-link :to="{ name: 'tinkAdmin' }" custom v-slot="{ navigate }">
                  <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                    <b>&rarr;</b> 관리자 시스템
                  </span>
                </router-link>
              </b-list-group-item>

              <b-list-group-item class="m-0 pl-3 pr-3 border-top-0" style="padding-top: 0.2rem; padding-bottom:0.1rem">

                <router-link :to="{ name: 'tinkUser', params: { uid: loginUser.id } }" custom v-slot="{ navigate }">
                  <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link" v-html="$t('tHeader.viewMyDeviceList')"></span>  
                </router-link>

              </b-list-group-item>

              <b-list-group-item class="m-0 pl-3 pr-3 border-top-0" style="padding-top: 0.2rem; padding-bottom:0.1rem">
                <router-link :to="{ name: 'tinkUser', params: { uid: loginUser.id }, query: { mode : 'add' } }" custom v-slot="{ navigate }">
                  <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link" v-html="$t('tHeader.registerDevice')"></span>
                </router-link>
              </b-list-group-item>
              <b-list-group-item class="m-0 pl-3 pr-3 border-top-0" style="padding-top: 0.2rem; padding-bottom:0.1rem">
                <span v-b-modal.editProfileFloat class="cursor-pointer text-primary">
                  {{ $t("tHeader.changeMyProfile") }}
                </span>
              </b-list-group-item>
              <b-list-group-item v-if="loginUser.emailVerified" class="m-0 pl-3 pr-3 border-top-0" style="padding-top: 0.2rem; padding-bottom:0.1rem">
                <span v-b-modal.updatePasswordFloat class="cursor-pointer text-primary">
                  {{ $t("tHeader.changePassword") }}
                </span>
              </b-list-group-item>

              <b-list-group-item v-if="loginUser.emailVerified" class="m-0 pl-3 pr-3 border-top-0" style="padding-top: 0.2rem; padding-bottom:0.1rem">
                <span v-b-modal.changeEmailAddressFloat class="cursor-pointer text-primary">
                  {{ $t("common.changeEmailAddress") }}
                </span>
              </b-list-group-item>

              <b-list-group-item class="m-0 pt-1 pb-1 pl-3 pr-3 border-top-0" style="padding-top: 0.2rem; padding-bottom:0.1rem">
                <b-button size="sm" @click="enterPresentation" variant="primary" class="mr-1" style="padding: 0.1rem 1rem 0.1rem 1rem;">
                  {{ $t("tHeader.presentationMode") }}
                </b-button>
                <b-button size="sm" @click="logout" variant="secondary" style="padding: 0.1rem 1rem 0.1rem 1rem;">
                  {{ $t("tHeader.logout") }}
                </b-button>
              </b-list-group-item>
            </b-list-group>
          </b-collapse>
        </div>

        <div>
          <div class="p-0 mr-2 ml-2 border">
            <h4 role="tab" v-b-toggle.folderList variant="light" class="m-0 p-2 font-weight-bold cursor-pointer fontSize1Dot1">
              <span style="vertical-align: -2px;">{{$t("common.deviceFolderList")}}</span>
              <b-button size="sm" variant="primary" v-b-modal.manageDeviceFolderFloat class="float-right pr-2 pl-2 tinyButton" @click="stopPropagation">
                {{ $t("common.edit")}}
              </b-button>
            </h4>
          </div>
          <b-collapse id="folderList" accordion="menuAccordion" role="tabpanel" class="m-0 p-0">

            <b-list-group squared class="mt-0 mr-2 ml-2 mb-0 border-top-0 rounded-0">

              <b-list-group-item class="m-0 pt-1 pl-2 pb-1 pr-1 border-top-0 fontSizeDot9">

                <div v-if="loginUserBinded && loginUserDeepBinding" role="tab" variant="light" class="m-0 ml-1 p-0 font-weight-bold cursor-pointer" @click="$root.$emit('bv::toggle::collapse', 'folderList_atRoot')">

                  <router-link :to="{ 'name': 'tinkUserFolder', 'params': { 'uid': loginUser.id, 'folder': '@root' } }" custom v-slot="{ navigate }">
                    <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                      / (@root)
                    </span>
                  </router-link>

                </div>

                <div v-else role="tab" variant="light" class="m-0 ml-1 p-0 font-weight-bold">

                  <router-link :to="{ 'name': 'tinkUser', params: { uid: loginUser.id, 'folder': '@root' } }" custom v-slot="{ navigate }">
                    <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                      / (@root)
                    </span>  
                  </router-link>

                </div>

                <b-collapse v-if="loginUserBinded && loginUserDeepBinding" id="folderList_atRoot" accordion="folderListAccordion" role="tabpanel" class="m-0 p-0">
                  <b-list-group squared class="mt-1 mr-1 ml-1 mb-2">
                    <b-list-group-item class="m-0 pt-1 pl-2 pb-1 pr-1" v-if="loginUserDeviceInfoGroupByFolder['@root'].length == 0">
                      <small>{{$t("common.empty")}}</small>
                    </b-list-group-item>

                    <b-list-group-item class="m-0 pt-1 pl-2 pb-1 pr-1" v-for="(device, index) in loginUserDeviceInfoGroupByFolder['@root']" :key="`folderList_atRoot_${index}`">
                      <b-badge variant="success" class="float-left mt-1 mr-1">d</b-badge>
                      <router-link :to="{ name: 'tinkDevice', params: { did: device.id } }" custom v-slot="{ navigate }">
                        <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                          {{device.id}}{{ loginUser.devices[device.id].name }}
                        </span>  
                      </router-link>
                    </b-list-group-item>

                  </b-list-group>
                </b-collapse>

              </b-list-group-item>

              <b-list-group-item class="m-0 pt-1 pl-2 pb-1 pr-1 border-top-0 fontSizeDot9" v-for="(folderItem) in loginUser.folders" :key="`folder_${folderItem}`">

                <div v-if="loginUserBinded && loginUserDeepBinding" role="tab" variant="light" class="m-0 ml-1 p-0 font-weight-bold cursor-pointer" @click="$root.$emit('bv::toggle::collapse', 'folderList_' + folderItem)">

                  <router-link :to="{ 'name': 'tinkUserFolder', params: { 'uid': loginUser.id, 'folder': folderItem } }" custom v-slot="{ navigate }">
                    <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                      {{folderItem}}
                    </span>
                  </router-link>

                </div>

                <div v-else role="tab" variant="light" class="m-0 ml-1 p-0 font-weight-bold">

                  <router-link :to="{ 'name': 'tinkUserFolder', params: { 'uid': loginUser.id, 'folder': folderItem } }" custom v-slot="{ navigate }">
                    <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                      {{folderItem}}
                    </span>  
                  </router-link>

                </div>

                <b-collapse v-if="loginUserBinded && loginUserDeepBinding" :id="`folderList_${folderItem}`" accordion="folderListAccordion" role="tabpanel" class="m-0 p-0">
                  <b-list-group squared class="mt-1 mr-1 ml-1 mb-2">

                    <b-list-group-item class="m-0 pt-1 pl-2 pb-1 pr-1" v-if="loginUserDeviceInfoGroupByFolder[folderItem].length == 0">
                      <small>{{$t("common.empty")}}</small>
                    </b-list-group-item>

                    <b-list-group-item class="m-0 pt-1 pl-2 pb-1 pr-1" v-for="(device, index) in loginUserDeviceInfoGroupByFolder[folderItem]" :key="`folderList_${folderItem}_${index}`">

                      <b-badge variant="success" class="float-left mt-1 mr-1">d</b-badge>

                      <router-link :to="{ 'name': 'tinkDevice', 'params': { 'did': device.id } }" custom v-slot="{ navigate }">
                        <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                          {{ loginUser.devices[device.id].name }}
                        </span>  
                      </router-link>

                    </b-list-group-item>
                  </b-list-group>
                </b-collapse>

              </b-list-group-item>

              <b-list-group-item class="m-0 pt-1 pl-2 pb-1 pr-1 border-top-0 fontSizeDot9">

                <div v-if="loginUserBinded && loginUserDeepBinding" role="tab" variant="light" class="m-0 ml-1 p-0 font-weight-bold cursor-pointer" @click="$root.$emit('bv::toggle::collapse', 'folderList_atAdmin')">

                  <router-link :to="{ 'name': 'tinkUserFolder', 'params': { 'uid': loginUser.id, 'folder': '@admin' } }" custom v-slot="{ navigate }">
                    <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                      @admin
                    </span>  
                  </router-link>

                </div>

                <div v-else role="tab" variant="light" class="m-0 ml-1 p-0 font-weight-bold">

                  <router-link :to="{ 'name': 'tinkUserFolder', 'params': { 'uid': loginUser.id, 'folder': '@admin' } }" custom v-slot="{ navigate }">
                    <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                      @admin
                    </span>  
                  </router-link>

                </div>

                <b-collapse v-if="loginUserBinded && loginUserDeepBinding" id="folderList_atAdmin" accordion="folderListAccordion" role="tabpanel" class="m-0 p-0">
                  <b-list-group squared class="mt-1 mr-1 ml-1 mb-2">

                    <b-list-group-item class="m-0 pt-1 pl-2 pb-1 pr-1" v-if="adminDevices.length == 0">
                      <small>{{$t("common.empty")}}</small>
                    </b-list-group-item>

                    <b-list-group-item class="m-0 pt-1 pl-2 pb-1 pr-1" v-for="(device, index) in adminDevices" :key="index">

                      <b-badge variant="success" class="float-left mt-1 mr-1">d</b-badge>

                      <router-link :to="{ 'name': 'tinkDevice', 'params': { 'did': device.id } }" custom v-slot="{ navigate }">
                        <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                          {{ loginUserAdminDeviceList[device.id].name }}
                        </span>  
                      </router-link>

                    </b-list-group-item>
                  </b-list-group>
                </b-collapse>

              </b-list-group-item>

              <b-list-group-item class="m-0 pt-1 pl-2 pb-1 pr-1 border-top-0 fontSizeDot9">

                <div v-if="loginUserBinded" role="tab" variant="light" class="m-0 ml-1 p-0 font-weight-bold">

                  <router-link :to="{ 'name': 'tinkUserFolder', 'params': { 'uid': loginUser.id, 'folder': '@friends' } }" custom v-slot="{ navigate }">
                    <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                      <b>&rarr;</b> @friends
                    </span>  
                  </router-link>

                </div>
              </b-list-group-item>

            </b-list-group>
          </b-collapse>
        </div>

        <div>
          <div class="p-0 mr-2 ml-2 border">

            <h4 role="tab" v-b-toggle.friendsList variant="light" class="m-0 p-2 font-weight-bold cursor-pointer fontSize1Dot1">
              {{ $t("common.myFriendsList") }}

              <b-badge v-if="loginUserFrReqArray.length != 0" pill v-b-modal.manageFriendsFloat variant="danger" size="sm" class="btn float-left mr-1 rounded-circle" style="min-width: 20px; height: 20px; margin-top: 0.1rem; padding: 0.2rem 0.1rem 0.1rem 0.1rem" @click="stopPropagation">{{loginUserFrReqArray.length}}</b-badge>

              <b-button size="sm" variant="primary" v-b-modal.manageFriendsFloat  class="float-right pr-2 pl-2 tinyButton" @click="stopPropagation">
                {{ $t("common.edit")}}
              </b-button>

            </h4>
          </div>
          <b-collapse id="friendsList" accordion="menuAccordion" role="tabpanel" class="m-0 p-0">
            <b-list-group squared class="mt-0 mr-2 ml-2 mb-0 border-top-0 rounded-0">
              <b-list-group-item class="m-0 pt-2 pl-3 pb-1 pr-3 border-top-0" v-if="loginUser.frApp.length == 0">
                <small>
                  {{ $t("common.empty") }}
                </small>
              </b-list-group-item>

              <b-list-group-item class="m-0 pt-1 pl-2 pb-1 pr-1 border-top-0 fontSizeDot9" v-for="friend in loginUser.frApp" :key="`friend_${friend}`">

                <b-badge variant="warning" class="float-left mt-1 mr-1">u</b-badge>

                <router-link v-if="typeof(loginUser.frAppCache[friend]) == 'undefined'" :to="{ name: 'tinkUser', params: { uid: friend } }" custom v-slot="{ navigate }">
                    <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                      {{ friend }}
                    </span>  
                </router-link>

                <span v-else>
                  <router-link :to="{ name: 'tinkUser', params: { uid: friend } }" custom v-slot="{ navigate }">
                    <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                      {{ loginUser.frAppCache[friend].displayName }}
                    </span>  
                  </router-link>
                  (<a :href="`mailto:${loginUser.frAppCache[friend].email}`">{{ loginUser.frAppCache[friend].email }}</a>)
                </span>

              </b-list-group-item>

            </b-list-group>
          </b-collapse>
        </div>

        <div>
          <div class="p-0 mr-2 ml-2 border">
            <h4 role="tab" v-b-toggle.bookmarksList variant="light" class="m-0 pt-2 pl-2 pr-2 pb-2 font-weight-bold cursor-pointer fontSize1Dot1">
              {{ this.$t("common.bookmarkList")}}
              <b-button size="sm" variant="primary" v-b-modal.manageBookmarkFloat  class="float-right pr-2 pl-2 tinyButton" @click="stopPropagation">
                {{ this.$t("common.edit")}}
              </b-button>
            </h4>
          </div>

          <b-collapse id="bookmarksList" accordion="menuAccordion" role="tabpanel" class="m-0 p-0">

            <b-list-group squared class="mt-0 mr-2 ml-2 mb-0 border-top-0 rounded-0">

              <b-list-group-item class="m-0 pt-1 pl-2 pb-1 pr-1 border-top-0 fontSizeDot9" v-for="(bookmarkList, listIndex) in loginUser.bookmarks" :key="`bookmarkList_${listIndex}`">

                <div role="tab" variant="light" class="m-0 p-0 font-weight-bold cursor-pointer" @click="$root.$emit('bv::toggle::collapse', 'bookmarkList_' + listIndex)">
                    {{bookmarkList.name}}
                </div>

                <b-collapse :id="`bookmarkList_${listIndex}`" :visible="listIndex==0" accordion="bookmarkAccordion" role="tabpanel" class="m-0 mt-1 p-0">
                  <b-list-group squared class="mt-0 mr-1 ml-1 mb-2">

                    <b-list-group-item class="m-0 pt-1 pl-1 pb-1 pr-1" v-if="bookmarkList.list.length == 0">
                      <small>{{$t("common.empty")}}</small>
                    </b-list-group-item>

                    <b-list-group-item class="m-0 pt-1 pl-1 pb-1 pr-1" v-for="(bookmark, index) in bookmarkList.list" :key="`bookmark_${listIndex}_${index}`">

                      <b-badge v-if="bookmark.type == 10" variant="warning" class="float-left mt-1 mr-1">u</b-badge>
                      <b-badge v-if="bookmark.type == 20" variant="success" class="float-left mt-1 mr-1">d</b-badge>
                      <b-badge v-if="bookmark.type == 30" variant="info" class="float-left mt-1 mr-1">s</b-badge>



                      <router-link v-if="bookmark.uid && bookmark.uName" :to="{ name: 'tinkUser', params: { uid: bookmark.uid.trim() } }" custom v-slot="{ navigate }">
                        <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                          {{bookmark.uName}}
                        </span>  
                      </router-link><span v-if="bookmark.uid && bookmark.uName">{{$t("common.apostropheS")}} </span>




                      <router-link v-if="bookmark.did && bookmark.dName" :to="{ name: 'tinkDevice', params: { did: bookmark.did.trim() } }" custom v-slot="{ navigate }">
                        <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                          {{bookmark.dName}}
                        </span>  
                      </router-link><span v-if="bookmark.did && bookmark.dName">{{$t("common.apostropheS")}} </span>

                      <router-link v-if="bookmark.type == 10 && bookmark.id && bookmark.name" :to="{ name: 'tinkUser', params: { uid: bookmark.id.trim() } }" custom v-slot="{ navigate }">
                        <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                          {{bookmark.name}}
                        </span>  
                      </router-link>

                      <router-link v-else-if="bookmark.type == 20 && bookmark.id && bookmark.name" :to="{ name: 'tinkDevice', params: { did: bookmark.id.trim() }, query: { mode: bookmark.mode } }" custom v-slot="{ navigate }">
                        <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                          {{bookmark.name}}
                        </span>  
                      </router-link>

                      <router-link v-else-if="bookmark.type == 30 && bookmark.id && bookmark.name" :to="{ name: 'tinkSensor', params: { sid: bookmark.id.trim() } }" custom v-slot="{ navigate }">
                        <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                          {{bookmark.name}}
                        </span>  
                      </router-link>

                    </b-list-group-item>
                  </b-list-group>
                </b-collapse>

              </b-list-group-item>
            </b-list-group>
          </b-collapse>
        </div>
      </div>

      <tinkList v-touch:swipe.stop v-if="showTicker && loginUserDeepBinding && loginUserSensorArrayHasData.length != 0" :controls="false" :start="0" :show="2" rowClass="headerTickerRow" class="headerTickerBox bg-blue-dark text-blue-lighter" :autoRotate="0" :swipeRightDisabled="true">

        <tinkListItem class="headerTickerSensorBox" v-for="(sensor,index) in loginUserSensorArrayHasData" :key="`sensor_${index}`">

          <div class="gothic text-center headerTickerDeviceName border border-bottom-0">
            <router-link :to="{ name: 'tinkDevice', params: { did: loginUserDeviceList[sensor.device].id} }" custom v-slot="{ navigate }">
              <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                {{loginUserDeviceList[sensor.device].name}}
              </span>
            </router-link>
          </div>

          <div class="gothic text-center headerTickerSensorName text-blue-dark bg-blue-lighter border border-bottom-0">
            <router-link :to="{ name: 'tinkSensor', params: { sid: sensor.id} }" custom v-slot="{ navigate }">
              <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                {{sensor.name}}
              </span>
            </router-link>
          </div>

          <div class="p-1 gothic headerTickerValueBox border" v-b-tooltip.hover.top :title="(sensor.lastValues)? dateToString(sensor.lastValues.t.toDate()): ''">
            <div v-for="(sensorValue, valueIndex) in sensor.values" :key="`sensor_${index}_${valueIndex}`">
              <div v-if="!sensorValue.hold" class="d-flex flex-nowrap justify-content-between headerTickerValue">
                <div class="headerTickerValueName">{{sensorValue.name}}</div>
                <div class="headerTickerValueValue">{{sensor.lastValues.v[valueIndex]}}</div>
                <div class="headerTickerValueUnit" v-if="sensorValue.unit">{{sensorValue.unit}}</div>
              </div>
            </div>
          </div>

        </tinkListItem>
      </tinkList>

    </b-sidebar>

    <b-modal v-touch:swipe.stop v-if="loginUser && loginUser.emailVerified" size="lg" id="editProfileFloat" tabindex="-1" static v-model="editProfileFloatShow" :title="$t('tHeader.editMyProfile')" @show="modalShowFocus" data-nextfocus="editProfileDisplayName" header-bg-variant="primary" header-text-variant="light" footer-bg-variant="light" footer-text-variant="primary" header-class="pt-2 pb-2 pr-3 pl-3" footer-class="pt-1 pb-1 pr-3 pl-3" content-class="border-0">
      <b-container fluid>
        <b-form @submit.stop.prevent class="was-validated">

          <b-row class="mb-1">
            <b-col sm="5">
              <label for="editProfileEmailAddress" class="pt-1 fontSizeDot9">{{$t("common.emailAddress")}}</label>
            </b-col>
            <b-col sm="7">
              <b-form-input  v-touch:swipe.stop type="email" trim readonly id="editProfileEmailAddress" :placeholder="loginUser.email" v-b-tooltip.focus :title="$t('tHeader.canNotEditEmailInHere')" size="sm" class="fontSizeDot8"/>
            </b-col>
          </b-row>

          <b-row class="mb-0">
            <b-col sm="5">
              <label for="editProfileDisplayName" class="pt-1 fontSizeDot9">
                {{$t("common.name")}}
              </label>
            </b-col>
            <b-col sm="7">
              <b-form-input  v-touch:swipe.stop type="text" id="editProfileDisplayName" v-model="loginUser.displayName" v-b-tooltip.focus :title="$t('tHeader.nameRule')" v-on:keyup="enterKeyChecker" data-nextfocus="editProfileDescription" minlength="2" maxlength="16" required trim size="sm" class="fontSizeDot8" autocomplete="false"/>
            </b-col>
          </b-row>

          <b-row class="mb-1">
            <b-col sm="5">
            </b-col>
            <b-col sm="7">
              <template v-for="{displayName, id} in
                currentUser.providerData.filter( item => item.displayName != '').filter( (el, index, ar) => {
                  let i= index+1;
                  for(i=(index+1);i<ar.length;i++) {
                    if(ar[i].displayName == el.displayName) return false
                  }
                  return true;
                })">
                <div v-if="displayName != null && displayName != loginUser.displayName" :key="id">
                  <small class="fontSizeDot9">{{displayName}}</small>
                  <b-button  size="sm" variant="outline-primary" class="p-0 pl-2 pr-2 m-0 ml-1 mr-2 align-middle fontSizeDot7" @click="applyDisplayName" :data-displayname="displayName">
                    {{$t("common.use")}}
                  </b-button>
                </div>
              </template>
            </b-col>
          </b-row>

          <b-row class="mb-1">
            <b-col sm="5">
              <label for="editProfileDescription" class="pt-1 fontSizeDot9">
                {{$t("common.introduction")}}
              </label>
            </b-col>
            <b-col sm="7">
              <b-form-textarea v-touch:swipe.stop type="text" id="editProfileDescription" v-b-tooltip.focus
              v-model="loginUser.description" :title="$t('tHeader.introductionRule')" maxlength="128" rows="2" trim class="gothic fontSizeDot9" size="sm"></b-form-textarea>
            </b-col>
          </b-row>

          <b-row class="mb-0">
            <b-col sm="5">
              <label for="editProfileOpen" class="pt-1 fontSizeDot9">
                {{$t("common.openOrNot")}}
              </label>
            </b-col>
            <b-col sm="7">
              <b-form-select v-b-tooltip.focus v-model="loginUser.open" :title="$t('tHeader.openOrNotRule')" :options="[
                  { value: true, text: $t('common.open')},
                  { value: false, text: $t('common.notOpen')},
                ]" id="editProfileOpen" size="sm" class="fontSizeDot8">
              </b-form-select>
            </b-col>
          </b-row>

          <b-row class="mb-0">
            <b-col sm="5">
              <label for="editProfileDeepBinding" class="pt-1 fontSizeDot9">
                {{$t("tHeader.deepBinding")}}
              </label>
            </b-col>
            <b-col sm="7">
              <b-form-select v-b-tooltip.focus v-model="loginUser.deepBinding" :title="$t('tHeader.deepBindingRule')" :options="[
                  { value: true, text: $t('common.use')},
                  { value: false, text: $t('common.notUse')},
                ]" id="editProfileDeepBinding" size="sm" class="fontSizeDot8">
              </b-form-select>
            </b-col>
          </b-row>

          <b-row class="mb-0">
            <b-col sm="5">
              <label for="editProfileOpenEmail" class="pt-1 fontSizeDot9">
                {{$t("tHeader.openEmail")}}
              </label>
            </b-col>
            <b-col sm="7">
              <b-form-select v-b-tooltip.focus v-model="loginUser.openEmail" :title="$t('tHeader.openEmailRule')" :options="[
                  { value: true, text: $t('common.open')},
                  { value: false, text: $t('common.notOpen')},
                ]" id="editProfileOpenEmail" size="sm" class="fontSizeDot8">
              </b-form-select>
            </b-col>
          </b-row>

          <b-row class="mb-0">
            <b-col sm="5">
              <label for="editProfileOpenFriends" class="pt-1 fontSizeDot9">
                {{$t("tHeader.openFriends")}}
              </label>
            </b-col>
            <b-col sm="7">
              <b-form-select v-b-tooltip.focus v-model="loginUser.openFriends" :title="$t('tHeader.openFriendsRule')" :options="[
                  { value: true, text: $t('common.open')},
                  { value: false, text: $t('common.notOpen')},
                ]" id="editProfileOpenFriends" size="sm" class="fontSizeDot8">
              </b-form-select>
            </b-col>
          </b-row>

          <b-row class="mb-0">
            <b-col sm="5">
              <label for="editProfileOpenBookmark" class="pt-1 fontSizeDot9">
                {{$t("tHeader.openBookmark")}}
              </label>
            </b-col>
            <b-col sm="7">
              <b-form-select v-b-tooltip.focus v-model="loginUser.openBookmark" :title="$t('tHeader.openBookmarkRule')" :options="[
                  { value: true, text: $t('common.open')},
                  { value: false, text: $t('common.notOpen')},
                ]" id="editProfileOpenBookmark" size="sm" class="fontSizeDot8">
              </b-form-select>
            </b-col>
          </b-row>

          <b-row class="mb-1">
            <b-col sm="5">
              <label for="editProfilePhotoURL" class="pt-1 fontSizeDot9">
                {{$t("tHeader.profilePhotoUrl")}}
              </label>
            </b-col>
            <b-col sm="7">
              <b-form-input  v-touch:swipe.stop type="url" trim id="editProfilePhotoURL" v-b-tooltip.focus :title="$t('tHeader.profilePhotoUrlRule')" v-on:keyup="enterKeyChecker" data-nextfocus="userProfileSaveButton" v-model="loginUser.photoURL" size="sm" class="fontSizeDot8"/>
            </b-col>
          </b-row>

          <b-row class="mb-0">
            <b-col sm="12" class="ml-2">
              <div style="float: left; position: relative;">
                <b-img id="editProfilePhotoPreview" :src="loginUser.photoURL" style="float: left; max-width: 12ex;" class="m-0 mr-2" v-if="loginUser.photoURL != ''"/>
                <b-badge variant="primary" pill style="position: absolute; top: 0.4rem; left: 0.4rem;" class="p-1 pl-2 pr-2 fontSizeDot7" v-if="loginUser.photoURL != ''">{{$t("common.preview")}}</b-badge>
              </div>
              <template v-for="{photoURL, id} in currentUser.providerData.filter( item => item.photoURL != '').filter((el, index, ar) => {
                  let i = index +1;
                  for(i=(index+1);i<ar.length;i++) {
                    if(ar[i].photoURL == el.photoURL) return false
                  }
                  return true
                })">
                <div v-if="photoURL != generatedIcon && photoURL != null && photoURL != '' && photoURL != loginUser.photoURL" :key="id" style="float: left; position: relative;">
                  <b-img :src="photoURL" class="m-0 mr-2" style="max-width: 12ex;"/>
                  <b-button size="sm" variant="secondary" style="position: absolute; bottom: 0.4rem; right: 0.8rem;" class="p-0 pr-2 pl-2 fontSizeDot7" @click="applyPhotoURL" :data-photourl="photoURL">{{$t("common.use")}}</b-button>
                </div>
              </template>
              <div v-if="loginUser.photoURL != generatedIcon" style="float: left; position: relative;">
                <b-img :src="generatedIcon" class="m-0 mr-2" style="max-width: 12ex;"/>
                <b-button  size="sm" variant="secondary" style="position: absolute; bottom: 0.4rem; right: 0.8rem;" class="p-0 pr-2 pl-2 fontSizeDot7" @click="applyPhotoURL" :data-photourl="generatedIcon">{{$t("common.use")}}</b-button>
              </div>
            </b-col>
          </b-row>
        </b-form>
      </b-container>
      <template slot="modal-footer" >
        <span>
          <b-button @click="requestRemoveUserProfile" size="sm" type="submit" variant="outline-secondary" id="userProfileSaveButton" class="fontSizeDot9 pl-3 pr-3 pt-1 pb-1 mr-2">
            회원 탈퇴 신청하기
          </b-button>
        </span>
        <span class="modalHeaderRight">
          <b-spinner small type="grow" class="mr-1" v-if="showUpdateUserProfileSpinner"></b-spinner>
          <b-button @click="userProfileSave" type="submit" variant="danger" id="userProfileSaveButton" class="fontSizeDot9 pl-3 pr-3 pt-1 pb-1">
            {{$t("common.save")}}
          </b-button>
        </span>
      </template>
    </b-modal>

    <b-modal v-touch:swipe.stop v-if="loginUser && loginUser.emailVerified" size="lg" id="updatePasswordFloat" tabindex="-1" :title="$t('tHeader.changePassword')" static v-model="updatePasswordFloatShow" @show="modalShowFocus" data-nextfocus="updatePasswordCurrentPassword,updatePasswordNewPassword" header-bg-variant="primary" header-text-variant="light" footer-bg-variant="light" footer-text-variant="primary" header-class="pt-2 pb-2 pr-3 pl-3" footer-class="pt-1 pb-1 pr-3 pl-3" content-class="border-0">
      <b-container fluid>
        <b-form @submit.stop.prevent class="was-validated">
          <b-row class="mb-1">
            <b-col sm="5">
              <label for="updatePasswordEmailAddress" class="pt-1">
                {{$t("common.emailAddress")}}
              </label>
            </b-col>
            <b-col sm="7">
              <b-form-input  v-touch:swipe.stop type="email" readonly id="updatePasswordEmailAddress" :placeholder="loginUser.email" v-b-tooltip.focus :title="$t('tHeader.canNotEditEmailInHere')"  size="sm"/>
            </b-col>
          </b-row>
          <b-row class="mb-2" v-if="providerId == 'password'">
            <b-col sm="5">
              <label for="updatePasswordCurrentPassword" class="pt-1">
                {{$t("tHeader.currentPassword")}}
              </label>
            </b-col>
            <b-col sm="7">
              <b-form-input  v-touch:swipe.stop type="password" id="updatePasswordCurrentPassword" v-b-tooltip.focus v-model="updatePasswordCurrentPassword" :title="$t('tHeader.currentPasswordTitle')" trim autocomplete="off"
              minlength="6" required v-on:keyup="enterKeyChecker" data-nextfocus="updatePasswordNewPassword" size="sm"/>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="5">
              <label for="updatePasswordNewPassword" class="pt-1">{{$t("tHeader.newPassword")}}</label>
            </b-col>
            <b-col sm="7">
              <b-form-input  v-touch:swipe.stop type="password" trim id="updatePasswordNewPassword" v-b-tooltip.focus v-model="updatePasswordNewPassword" v-on:keyup="enterKeyChecker" minlength="6" data-nextfocus="updatePasswordButton" required :title="$t('tHeader.passwordRule')" autocomplete="off"  size="sm"/>
            </b-col>
          </b-row>
          <b-row class="mb-2" v-if="providerId != 'password'">
            <b-col sm="12">
              <b-form-text class="gothic" size="sm">
                {{$t("tHeader.newPasswordMessage")}}
              </b-form-text>
            </b-col>
          </b-row>
        </b-form>
      </b-container>
      <template slot="modal-footer">
        <b-spinner small type="grow" class="mr-1" v-if="showUpdatePasswordSpinner"></b-spinner>
        <b-button type="button" @click="updatePassword" id="updatePasswordButton" variant="primary">
          {{$t("tHeader.changePassword")}}
        </b-button>
      </template>
    </b-modal>

    <b-modal v-touch:swipe.stop v-if="loginUser && loginUser.emailVerified" size="lg" id="changeEmailAddressFloat" tabindex="-1" :title="$t('common.changeEmailAddress')" static v-model="changeEmailAddressFloatShow" @show="modalShowFocus" data-nextfocus="changeEmailAddressPassword,changeEmailAddressNewEmailAddress" header-bg-variant="primary" header-text-variant="light" footer-bg-variant="light" footer-text-variant="primary" header-class="pt-2 pb-2 pr-3 pl-3" footer-class="pt-1 pb-1 pr-3 pl-3" content-class="border-0">
      <b-container fluid>
        <b-form @submit.stop.prevent class="was-validated">
          <b-row class="mb-1">
            <b-col sm="5">
              <label for="changeEmailAddressCurrentEmailAddress" class="pt-1">{{$t("tHeader.currentEmailAddress")}}</label>
            </b-col>
            <b-col sm="7">
              <b-form-input  v-touch:swipe.stop type="email" readonly id="changeEmailAddressCurrentEmailAddress"
              :placeholder="loginUser.email"/>
            </b-col>
          </b-row>
          <b-row class="mb-2" v-if="providerId == 'password'">
            <b-col sm="5">
              <label for="changeEmailAddressPassword">{{$t("tHeader.currentPassword")}}</label>
            </b-col>
            <b-col sm="7">
              <b-form-input  v-touch:swipe.stop type="password" trim id="changeEmailAddressPassword" v-b-tooltip.focus minlength="6" required v-model="changeEmailAddressPassword" :title="$t(tUserFloat.currentPasswordTitle)" v-on:keyup="enterKeyChecker" data-nextfocus="changeEmailAddressNewEmailAddress" autocomplete="off" size="sm"/>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="5">
              <label for="changeEmailAddressNewEmailAddress" class="pt-1">{{$t("tHeader.newEmailAddress")}}</label>
            </b-col>
            <b-col sm="7">
              <b-form-input  v-touch:swipe.stop type="email" id="changeEmailAddressNewEmailAddress" trim v-model="changeEmailAddressNewEmailAddress" v-on:keyup="enterKeyChecker" required data-nextfocus="updateEmailAddressButton" v-b-tooltip.focus autocomplete="off" :title="$t('tHeader.newEmailAddressTitle')" size="sm"/>
            </b-col>
          </b-row>
          <b-row class="mb-2" v-if="providerId != 'password'">
            <b-col sm="12">
              <b-form-text class="gothic" size="sm">
                {{$t("tHeader.newEmailAddressMessage")}}
              </b-form-text>
            </b-col>
          </b-row>
        </b-form>
      </b-container>
      <template slot="modal-footer">
        <b-spinner small type="grow" class="mr-1" v-if="showUpdateEmailAddressSpinner"></b-spinner>
        <b-button @click="updateEmailAddress" id="updateEmailAddressButton" variant="primary">
          {{$t("common.changeEmailAddress")}}
        </b-button>
      </template>
    </b-modal>


    <b-modal v-touch:swipe.stop v-if="loginUser && loginUserBinded" size="lg" id="manageDeviceFolderFloat" tabindex="-1" :title="$t('tHeader.manageDeviceFolder')" v-model="manageDeviceFolderFloatShow" static @show="modalShowFocus" data-nextfocus="manageFolderFloatButton" header-bg-variant="primary" header-text-variant="light" footer-bg-variant="light" footer-text-variant="primary" header-class="pt-2 pb-2 pr-3 pl-3" footer-class="pt-1 pb-1 pr-3 pl-3" content-class="border-0">

      <p class="gothic pt-0 pb-0 pr-2 pl-2 fontSizeDot8 mb-0 mt-0" v-if="!loginUserDeepBinding">
        &#8251; {{$t("tHeader.showDeviceIdNotDeviceNameNotice")}}
      </p>

      <b-list-group squared class="text-left mt-0 mr-2 ml-2 mb-2 border-top-0 rounded-0">

        <b-list-group-item class="m-0 p-1 pl-2">

          <div role="tab" variant="light" class="m-1 p-0 font-weight-bold cursor-pointer" @click="$root.$emit('bv::toggle::collapse', 'folder_atRoot')">
              / (@root)
          </div>

          <b-collapse id="folder_atRoot" :visible="true" accordion="folderAccordion" role="tabpanel" class="m-0 p-0"  v-if="loginUserDeviceInfoGroupByFolder['@root'].length > 0">

            <b-list-group squared class="mt-0 mr-1 ml-1 mb-2">

              <b-list-group-item class="m-0 p-1 pl-2 fontSizeDot9" v-for="(device, index) in loginUserDeviceInfoGroupByFolder['@root']" :key="`folderDevice_atRoot_${device.id}`">

                <span class="d-inline-block mt-dot2">
                  <router-link v-if="loginUserDeepBinding" :to="{ name: 'tinkDevice', params: { did: device.id } }" custom v-slot="{ navigate }">
                    <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                      {{loginUser.devices[device.id].name}}
                    </span>  
                  </router-link>

                  <router-link v-else-if="device.name" :to="{ name: 'tinkDevice', params: { did: device.id } }" custom v-slot="{ navigate }">
                    <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                      {{device.name}}
                    </span>  
                  </router-link>

                  <router-link v-else :to="{ name: 'tinkDevice', params: { did: device.id } }" custom v-slot="{ navigate }">
                    <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                      {{device.id}}
                    </span>  
                  </router-link>
                </span>

                <b-dropdown v-if="loginUser.folders.length >= 1" size="sm" :text="$t('common.move')" class="float-right m-0 mr-0 fontSizeDot8 pl-2 pr-2 pt-dot1 pb-0" variant="primary" toggle-class="m-0 mr-0 fontSizeDot8 pl-2 pr-2 pt-dot1 pb-0">

                  <b-dropdown-item-button :disabled="true" @click="manageDeviceFolderMoveDevice('@root', device.id, '@root')">/</b-dropdown-item-button>

                  <b-dropdown-item-button v-for="(item, pos) in loginUser.folders" :key="`folderDeviceDropdown_${item}_${pos}`" @click="manageDeviceFolderMoveDevice('@root', device.id, item)">{{item}}</b-dropdown-item-button>

                </b-dropdown>

                <b-button @click="manageDeviceFolderDownDevice('@root', device.id)" :disabled="index == (loginUserDeviceInfoGroupByFolder['@root'].length-1)" class="float-right fontSizeDot8 m-0 mr-1 pt-dot1 pb-dot1" size="sm" variant="secondary">
                  &darr;
                </b-button>

                <b-button @click="manageDeviceFolderUpDevice('@root', device.id)" :disabled="index==0" class="float-right fontSizeDot8 m-0 mr-1 pt-dot1 pb-dot1" size="sm" variant="secondary">
                  &uarr;
                </b-button>

              </b-list-group-item>

            </b-list-group>

          </b-collapse>
        </b-list-group-item>


        <b-list-group-item class="m-0 tinyPadding pl-1" v-for="(folderItem, listIndex) in loginUser.folders" :key="`folder_${folderItem}_${listIndex}`">

          <div role="tab" variant="light" class="m-1 ml-0 mr-2 p-0 font-weight-bold cursor-pointer" @click="$root.$emit('bv::toggle::collapse', 'folder_' + listIndex)">

            <b-input-group>

              <b-form-input  v-touch:swipe.stop autocomplete="off" :id="`folderInput_${folderItem}`" class="p-0 pl-2 font-weight-bold" trim size="sm" :value="folderItem"/>

              <b-input-group-append class="pt-0 pb-0">

                <b-button @click="manageDeviceFolderRenameFolder(folderItem)" class="pr-2 pl-2 pt-0 pb-0 fontSizeDot8" size="sm" variant="primary">
                  {{$t("common.rename")}}
                </b-button>
              </b-input-group-append>


              <b-input-group-append class="pt-0 pb-0">
                <b-button @click="manageDeviceFolderRemoveFolder(folderItem)" class="pr-2 pl-2 pt-1 pb-1 fontSizeDot8" size="sm" variant="secondary">
                  {{$t("common.delete")}}
                </b-button>

              </b-input-group-append>

            </b-input-group>
          </div>

          <b-collapse :id="`folder_${listIndex}`" accordion="folderAccordion" role="tabpanel" class="m-0 p-0" v-if="loginUserDeviceInfoGroupByFolder[folderItem].length > 0">

            <b-list-group squared class="mt-0 mr-1 ml-1 mb-2">

              <b-list-group-item class="m-0 p-1 pl-2 fontSizeDot9" v-for="(device, index) in loginUserDeviceInfoGroupByFolder[folderItem]" :key="`folderDevice_${device.id}_${index}`">

                <span class="d-inline-block mt-dot2">
                  <router-link v-if="loginUserDeepBinding" :to="{ name: 'tinkDevice', params: { did: device.id } }" custom v-slot="{ navigate }">
                    <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                      {{loginUser.devices[device.id].name}}
                    </span>  
                  </router-link>

                  <router-link v-else-if="device.name" :to="{ name: 'tinkDevice', params: { did: device.id } }" custom v-slot="{ navigate }">
                    <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                      {{device.name}}
                    </span>  
                  </router-link>

                  <router-link v-else :to="{ name: 'tinkDevice', params: { did: device.id } }" custom v-slot="{ navigate }">
                    <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                      {{device.id}}
                    </span>  
                  </router-link>
                </span>

                <b-dropdown v-if="loginUser.folders.length >= 1" size="sm" :text="$t('common.move')" class="float-right m-0 mr-1 fontSizeDot8 pt-0 pt-dot1" variant="primary" toggle-class="m-0 mr-1 fontSizeDot8 pt-0 pt-dot1">

                  <b-dropdown-item-button @click="manageDeviceFolderMoveDevice(folderItem, device.id, '@root')">/</b-dropdown-item-button>

                  <b-dropdown-item-button v-for="(item, pos) in loginUser.folders" :key="`folderDeviceDropdown_${item}_${pos}`" :disabled="pos == listIndex" @click="manageDeviceFolderMoveDevice(folderItem, device.id, item)">{{item}}</b-dropdown-item-button>

                </b-dropdown>

                <b-button @click="manageDeviceFolderDownDevice(folderItem, device.id)" :disabled="index == (loginUserDeviceInfoGroupByFolder[folderItem].length-1)" class="float-right fontSizeDot8 m-0 mr-1 pt-dot1 pb-dot1" size="sm" variant="secondary">
                  &darr;
                </b-button>

                <b-button @click="manageDeviceFolderUpDevice(folderItem, device.id)" :disabled="index==0" class="float-right fontSizeDot8 m-0 mr-1 pt-dot1 pb-dot1" size="sm" variant="secondary">
                  &uarr;
                </b-button>

              </b-list-group-item>

            </b-list-group>

          </b-collapse>
        </b-list-group-item>

      </b-list-group>

      <div class="border p-1 pt-1 m-2 gothic fontSize1">
        <b-form @submit.stop.prevent class="was-validated" ref="newFolderForm" name="newFolderForm">
          <b-input-group>
            <b-input-group-prepend class="p-1 pr-3 fontSizeDot9">
              {{$t("common.folderName")}}
            </b-input-group-prepend>
            <b-form-input  v-touch:swipe.stop v-model="newDeviceFolderName" name="newDeviceFolderName" autocomplete="off" required class="p-0 pl-2" size="sm" trim pattern="[a-zA-Z_][0-9a-zA-Z_]{1,}" minlength="2" maxlength="32" v-b-tooltip.focus :title="$t('tHeader.folderNameRule')"/>
            <b-input-group-append class="pt-0 pb-0">
              <b-button @click="manageDeviceFolderAddFolder" :disabled="requestDisabled || newDeviceFolderName==''" size="sm" variant="primary" class="mr-2 pr-2 pl-2 pt-1 pb-1 fontSizeDot8">
                {{$t("common.add")}}
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </div>



      <template slot="modal-footer">
        <b-spinner small type="grow" class="mr-1" v-if="showManageDeviceFolderSpinner"></b-spinner>
        <b-button @click="manageDeviceFolderSave" id="manageFolderFloatButton" variant="danger" v-b-tooltip.hover.bottom :title="$t('tHeader.manageDeviceFolderSaveTitle')" class="fontSizeDot9 pl-3 pr-3 pt-1 pb-1">
          {{$t("common.save")}}
        </b-button>
      </template>
    </b-modal>

    <b-modal v-touch:swipe.stop v-if="loginUser" size="lg" id="manageFriendsFloat" tabindex="-1" :title="$t('tHeader.manageFriendsList')" v-model="manageFriendsFloatShow" static @show="modalShowFocus" data-nextfocus="manageFriendsFloatButton" header-bg-variant="primary" header-text-variant="light" footer-bg-variant="light" footer-text-variant="primary" header-class="pt-2 pb-2 pr-3 pl-3" footer-class="pt-1 pb-1 pr-3 pl-3" content-class="border-0">

      <b-list-group squared class="text-left mt-0 mr-2 ml-2 mb-2">

        <b-list-group-item class="m-0 p-dot2 pb-1 pl-2 tinyPadding fontSizeDot9" v-for="(friend,index) in loginUser.frApp" :key="`friend_${index}`">

          <router-link v-if="typeof(loginUser.frAppCache[friend]) == 'undefined'" :to="{ name: 'tinkUser', params: { uid: friend } }" class="d-inline-block mt-dot1" custom v-slot="{ navigate }">
              <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                {{ friend }}
              </span>  
          </router-link>
          <span v-else class="d-inline-block mt-dot1">
            <router-link v-if="loginUser.frAppCache[friend].displayName" :to="{ name: 'tinkUser', params: { uid: friend } }" custom v-slot="{ navigate }">
              <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                {{ loginUser.frAppCache[friend].displayName }}
              </span>  
            </router-link>
            <router-link v-else :to="{ name: 'tinkUser', params: { uid: friend } }" custom v-slot="{ navigate }">
              <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                {{ friend }}
              </span>  
            </router-link>
            <span v-if="loginUser.frAppCache[friend].email">
              (<a :href="`mailto:${loginUser.frAppCache[friend].email}`">{{ loginUser.frAppCache[friend].email }}</a>)
            </span>
          </span>
          <b-button @click="manageFriendsRemoveFriend(friend, index)" class="float-right mr-3 fontSizeDot8 pb-dot1 pt-dot1" size="sm" variant="secondary">
            {{$t("common.delete")}}
          </b-button>
        </b-list-group-item>

        <b-list-group-item class="m-0 p-1 pl-2">
          <b-form @submit.stop.prevent class="was-validated" id="newFriendIdForm" name="newFriendIdForm">
            <b-input-group>
              <b-input-group-prepend class="p-1 pr-3 fontSizeDot9">
                {{this.$t("common.idOrEmail")}}
              </b-input-group-prepend>
              <b-form-input  v-touch:swipe.stop autocomplete="off" v-model="newFriendId" name="newFriendId" required class="p-0 pl-2" size="sm" pattern="^([^\s@]+@[^\s@]+\.[^\s@]{2,})|([a-zA-Z0-9]{28})$" trim minlength="4" maxlength="64" v-b-tooltip.focus :title="$t('common.idOrEamilRule')"/>
              <b-input-group-append class="pt-0 pb-0">
                <b-button @click="manageFriendsAddFriend" :disabled="requestDisabled" size="sm" variant="primary" class="mr-2 pr-2 pl-2 pt-1 pb-1">
                  {{this.$t("tHeader.addAsFriend")}}
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form>
        </b-list-group-item>
      </b-list-group>


      <div v-if="loginUserFrReqArray.length != 0">
        <h4 class="text-left mt-3 mr-2 ml-2 mb-0 p-2">
          {{ this.$t("tHeader.friendRequested") }}
          <b-badge pill variant="danger" size="sm" class="text-align-center p-0 pt-1" style="min-width: 1.3rem; height: 1.3rem;">
            {{loginUserFrReqArray.length}}
          </b-badge>
        </h4>
        <b-list-group squared class="text-left mt-0 mr-2 ml-2 mb-2">
          <b-list-group-item class="m-0 p-dot2 pl-2 fontSizeDot9" v-if="loginUserFrReqArray.length == 0">
            {{this.$t("common.empty")}}
          </b-list-group-item>
          <b-list-group-item v-else class="m-0 p-dot2 fontSizeDot9 pl-2" v-for="friend in loginUserFrReqArray" :key="`friendReq_${friend}`">
            <span class="d-inline-block mt-dot1">
              <router-link :to="{ name: 'tinkUser', params: { uid: friend[0] } }" custom v-slot="{ navigate }">
                <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                  {{ friend[1].displayName }}
                </span>  
              </router-link>
              (<a :href="`mailto:${friend[1].email}`">{{ friend[1].email}}</a>)
            </span>
            <b-button @click="manageFriendsReqRemoveFriend(friend[0])" class="float-right mr-2 pt-dot1 pb-dot1 fontSizeDot8" size="sm" variant="secondary">
              {{ $t("common.delete") }}
            </b-button>
            <b-button @click="manageFriendsReqMove2Friend(friend[0])" class="float-right mr-2 pt-dot1 pb-dot1 fontSizeDot8" size="sm" variant="primary">
              {{ $t("tHeader.addAsFriend") }}
            </b-button>
          </b-list-group-item>
        </b-list-group>
      </div>
      <template slot="modal-footer">
        <b-spinner small type="grow" class="mr-1" v-if="showManageFriendsSpinner"></b-spinner>
        <b-button @click="manageFriendsSave" id="manageFriendsFloatButton" variant="danger" v-b-tooltip.hover.bottom :title="$t('tHeader.manageFriendsSaveTitle')" class="fontSizeDot9 pl-3 pr-3 pt-1 pb-1">
          {{$t("common.save")}}
        </b-button>
      </template>
    </b-modal>

    <b-modal v-touch:swipe.stop v-if="loginUser" size="lg" id="manageBookmarkFloat" tabindex="-1" :title="$t('tHeader.manageBookmark')" v-model="manageBookmarkFloatShow" static @show="modalShowFocus" data-nextfocus="manageBookmarkFloatButton" header-bg-variant="primary" header-text-variant="light" footer-bg-variant="light" footer-text-variant="primary" header-class="pt-2 pb-2 pr-3 pl-3" footer-class="pt-1 pb-1 pr-3 pl-3" content-class="border-0">

      <div v-if="this.newBookmarkObject" class="m-2 p-1 pl-3 gothic border fontSizeDot9">
        {{$t("tHeader.bookmarkToAdd")}}:
        <span v-if="this.newBookmarkObject.type == 10">
          <b>{{this.newBookmarkObject.name}}</b> {{$t("common.user")}}
        </span>
        <span v-else-if="this.newBookmarkObject.type == 20">
          <b>{{this.newBookmarkObject.name}}</b> {{$t("common.device")}}
        </span>
        <span v-else>
          <b>{{this.newBookmarkObject.name}}</b> {{$t("common.sensor")}}
        </span>
        ({{this.newBookmarkObject.id}})
      </div>

      <b-list-group squared class="text-left mt-0 mr-2 ml-2 mb-2 border-top-0 rounded-0">

        <b-list-group-item class="m-0 p-1 pl-2" v-for="(bookmarkList, listIndex) in loginUser.bookmarks" :key="`bookmarkList_${listIndex}`">

          <div role="tab" variant="light" class="m-1 p-0 font-weight-bold cursor-pointer" @click="$root.$emit('bv::toggle::collapse', 'bookmarkList_' + listIndex)">

            <b-input-group>

              <b-form-input  v-touch:swipe.stop autocomplete="off" class="p-0 pl-2 font-weight-bold" trim size="sm" v-model="bookmarkList.name"/>

              <b-input-group-append class="pt-0 pb-0" v-if="newBookmarkObject">
                <b-button @click="manageBookmarkAddHere(listIndex)" size="sm" variant="danger" class="pr-2 pl-2 pt-1 pb-1">
                  {{$t("common.addHere")}}
                </b-button>
              </b-input-group-append>


              <b-input-group-append class="pt-0 pb-0" v-if="newBookmarkObject">
                <b-button @click="manageBookmarkAddCancel" size="sm" variant="secondary" class="mr-2 pr-3 pl-3 pt-1 pb-1">
                  {{$t("common.cancel")}}
                </b-button>
              </b-input-group-append>

              <b-input-group-append class="pt-0 pb-0" v-if="loginUser.bookmarks.length > 1 && !newBookmarkObject">
                <b-button @click="manageBookmarkRemoveFolder(listIndex)" :disabled="bookmarkList.list.length != 0" size="sm" variant="primary" class="mr-2 pr-2 pl-2 pt-1 pb-1">
                  {{$t("common.delete")}}
                </b-button>
              </b-input-group-append>

            </b-input-group>

          </div>

          <b-collapse :id="`bookmarkList_${listIndex}`" :visible="listIndex==0" accordion="bookmarkAccordion" role="tabpanel" class="m-0 p-0">
            <b-list-group squared class="mt-0 mr-1 ml-1 mb-2">

              <b-list-group-item class="m-0 p-1" v-for="(bookmark, index) in bookmarkList.list" :key="`bookmark_${listIndex}_${index}`">

                <span class="d-inline-block mt-dot1 pl-2">
                  <b-badge v-if="bookmark.type == 10" variant="warning" class="float-left mt-1 mr-1">u</b-badge>
                  <b-badge v-if="bookmark.type == 20" variant="success" class="float-left mt-1 mr-1">d</b-badge>
                  <b-badge v-if="bookmark.type == 30" variant="info" class="float-left mt-1 mr-1">s</b-badge>

                  <router-link v-if="bookmark.uid && bookmark.uName" :to="{ name: 'tinkUser', params: { uid: bookmark.uid.trim() } }" class="fontSizeDot8" custom v-slot="{ navigate }">
                    <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                      {{bookmark.uName}}
                    </span>  
                  </router-link>
                  <span v-if="bookmark.uid && bookmark.uName" class="fontSizeDot8">{{$t("common.apostropheS")}}</span>

                  <router-link v-if="bookmark.did && bookmark.dName" :to="{ name: 'tinkDevice', params: { did: bookmark.did.trim() } }" class="fontSizeDot8" custom v-slot="{ navigate }">
                    <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                      {{bookmark.dName}}
                    </span>  
                  </router-link>
                  <span v-if="bookmark.did && bookmark.dName" class="fontSizeDot8">{{$t("common.apostropheS")}}</span>


                  <router-link v-if="bookmark.type == 10 && bookmark.id && bookmark.name" :to="{ name: 'tinkUser', params: { uid: bookmark.id.trim() } }" class="fontSizeDot8" custom v-slot="{ navigate }">
                    <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                      {{bookmark.name}}
                    </span>  
                  </router-link>

                  <router-link v-if="bookmark.type == 20 && bookmark.id && bookmark.name" :to="{ name: 'tinkDevice', params: { did: bookmark.id.trim() } }" class="fontSizeDot8" custom v-slot="{ navigate }">
                    <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                      {{bookmark.name}}
                    </span>  
                  </router-link>

                  <router-link v-if="bookmark.type == 30 && bookmark.id && bookmark.name" :to="{ name: 'tinkSensor', params: { sid: bookmark.id.trim() } }" class="fontSizeDot8" custom v-slot="{ navigate }">
                    <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                      {{bookmark.name}}
                    </span>  
                  </router-link>
                </span>

                <b-dropdown v-if="loginUser.bookmarks.length > 1" size="sm" :text="$t('common.move')" class="float-right pt-dot1 pb-dot1 fontSizeDot8" variant="primary" toggle-class="pt-dot1 pb-dot1 fontSizeDot8 mr-2">

                  <b-dropdown-item-button v-for="(item, pos) in loginUser.bookmarks" :key="`bookmarkListDropdown_${pos}`" :disabled="pos == listIndex" @click="manageBookmarkMoveBookmark(listIndex, index, pos)">{{item.name}}</b-dropdown-item-button>

                </b-dropdown>

                <b-button @click="manageBookmarkRemoveBookmark(listIndex, index)"  class="float-right mr-2 mt-dot1 pt-dot1 pb-dot1 fontSizeDot8" size="sm" variant="secondary">
                  {{$t("common.delete")}}
                </b-button>

              </b-list-group-item>

            </b-list-group>
          </b-collapse>

        </b-list-group-item>

        <b-list-group-item class="m-0 p-1 pl-2">
          <b-input-group>
            <b-input-group-prepend class="p-1 pr-3 fontSizeDot9">
              {{this.$t("common.folderName")}}
            </b-input-group-prepend>
            <b-form-input  v-touch:swipe.stop v-model="newBookmarkFolderName" autocomplete="off" trim class="p-0 pl-2" size="sm" />
            <b-input-group-append class="pt-0 pb-0">
              <b-button @click="manageBookmarkAddFolder()" size="sm" variant="primary" class="mr-2 pr-2 pl-2 pt-1 pb-1">
                {{this.$t("common.add")}}
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-list-group-item>
      </b-list-group>
      <template slot="modal-footer">
        <b-spinner small type="grow" class="mr-1" v-if="showManageBookmarkSpinner"></b-spinner>
        <b-button @click="manageBookmarkSave" id="manageBookmarkFloatButton" variant="danger" v-b-tooltip.hover.bottom :title="$t('tHeader.manageBookmarkSaveTitle')" class="fontSizeDot9 pl-3 pr-3 pt-1 pb-1">
          {{$t("common.save")}}
        </b-button>
      </template>
    </b-modal>

    <b-modal v-touch:swipe.stop id="loginFloat" tabindex="-1" hide-footer hide-header static v-model="loginFloatShow" @show="modalShowFocus" data-nextfocus="loginFloatBody" content-class="border-0">
      <div id="loginFloatBody"></div>
    </b-modal>

  </div>
</template>

<script>

  import enImg from '@/assets/img/icon/usaEng.png'
  import koImg from '@/assets/img/icon/taegeuk.svg'
  import onestopImg from '@/assets/img/onestop.svg'

  import firebase from "firebase/app";
  import "firebase/auth";
  import "firebase/firestore";
  import { db } from "@/plugins/firebase.js"

  import eventBus from "@/plugins/eventBus.js";
  import uiUtil from "@/mixins/util.js";
  import user from "@/mixins/user.js";
  import functions from "@/mixins/functions.js"

  import {tinkList, tinkListItem} from "@/components/common/tinkList.vue"

  import * as firebaseui from "firebaseui";

  import { firebaseUiConfig } from "@/firebaseUiConfig";
  import "@/../node_modules/firebaseui/dist/firebaseui.css";

  import { mapActions } from "vuex";
  import { mapState } from "vuex";
  import { mapSetter } from "@/plugins/vuexUtils.js";


  export default {
    name: "tHeader",
    mixins: [uiUtil, user, functions],
    components: {
      tinkList,
      tinkListItem
    },
    injects: ["logout"],
    created() {
      this.$log.debug("tUserFloat created");
      firebase.auth().onAuthStateChanged(() => {
        this.loginFloatShow = false
      })
    },
    beforeDestory() {
      this.$log.debug("tUserFloat beforeDestory");
        window.clearInterval(this.emailVerifiedChecker);
    },
    updated() {
      this.$log.debug("tHeader updated", "loginUserDeepBinding", this.loginUserDeepBinding);
    },
    mounted: function() {
      this.changeLang(this.getLang());

      eventBus.$on('busUiShow', uiModelName => {
        this[uiModelName] = true;
      });

      eventBus.$on('busAddFriend', user => {
        this.manageFriendsAddFriendByObject(user);
      });

      eventBus.$on('busAddBookmark', obj => {
        this.manageBookmarkAddBookmarkByObject(obj);
      });

      eventBus.$on('busUiHide',uiModelName => {
        this[uiModelName] = false;
      });

      eventBus.$on('busUserFloatLogout', () => {
        this.logout()
      })

      eventBus.$on('busSendConfirmMail', () => {
        this.sendConfirmMail()
      })

      this.authUi = firebaseui.auth.AuthUI.getInstance()
      if(!this.authUi) {
        this.authUi = new firebaseui.auth.AuthUI(firebase.auth())
      }

      this.authUi.start("#loginFloatBody", firebaseUiConfig)

      window.setTimeout(() => {
        this.loginDisabled = false
      }, 3000)
    },
    data() {
      return {
        "newFriendId": "",
        "newBookmarkFolderName": "",
        "newDeviceFolderName": "",
        "newBookmarkObject": null,

        "showTicker": true,

        "loginDisabled": true,
        "requestDisabled": false,
        "selectedLang": "ko",
        "onestopImgSrc": onestopImg,
        "langs" : [
          { "name": "ko", "src": koImg, "alt": "한글", "title": "한글로 보기" },
          { "name": "en", "src": enImg, "alt": "English", "title": "In English" },
        ],
        "langIndex": {
          "ko": 0,
          "en": 1
        },
        generatedIcon: 'https://robohash.org/' + Math.floor(Math.random() * 1000000),
        emailVerifiedCheckerCount: 0,
        emailVerifiedChecker: null,
        updatePasswordCurrentPassword: "",
        updatePasswordNewPassword: "",
        changeEmailAddressPassword: "",
        changeEmailAddressNewEmailAddress: "",

        showUpdateUserProfileSpinner: false,
        showUpdatePasswordSpinner: false,
        showUpdateEmailAddressSpinner: false,
        showManageFriendsSpinner: false,
        showManageBookmarkSpinner: false,
        showManageDeviceFolderSpinner: false,

        // userProfileOpenOld: false,

        myMenuShow: false,
        loginFloatShow: false,
        editProfileFloatShow: false,
        updatePasswordFloatShow: false,
        changeEmailAddressFloatShow: false,

        manageFriendsFloatShow: false,
        manageBookmarkFloatShow: false,
        manageDeviceFolderFloatShow: false,
      }
    },
    methods: {
      requestRemoveUserProfile: function() {
        /*
        if(this.loginUserDeviceArray.length != 0) {
          window.alert("등록된 기기가 있어 회원탈퇴 신청을 할 수 없습니다. 먼저 등록된 기기를 삭제하세요.");
          return;
        }
        */
        this.$bvModal.msgBoxConfirm("회원탈퇴 신청을 하면 1. 사이트 이용이 즉시 정지되고 2. 향후 1년간 재가입이 금지되며 3. 회원탈퇴 신청을 취소할 수도 없습니다. 회원탈퇴 신청을 할까요?", {
          size: "sm",
          buttonSize: "md",
          okVariant: "secondary",
          okTitle: "신청하기",
          cancelTitle: "계속 이용하기",
          cancelVariant: "danger",
          bodyClass: "gothic",
          footerClass: "p-1 pr-3",
          hideHeaderClose: true,
        })
        .then(confirmed => {
          if(confirmed) {
            db.collection("users").doc(this.loginUser.id).update({
              "withdrawn": true,
              "withdrawnTime": firebase.firestore.FieldValue.serverTimestamp()
            })
            .then(() => {
              window.alert("회원탈퇴 신청되었습니다.");
              this.logout();
            });
          }
        });    
      },
      startOneStopAddDevice: function() {
        this.$router.push({ name: 'tinkUser', params: { uid: this.loginUser.id}, query: { mode: 'add', action:'addDevice' }}, ()=>{});
      },

      swipeApp: function(direction) {
        this.$log.debug("swife", direction);
        if(direction == "left") {
          eventBus.$emit("busUiShow", "myMenuShow");
          eventBus.$emit("busShowPageUser", false);
        }
        else if(direction == "right") {
          eventBus.$emit("busUiHide", "myMenuShow");
          eventBus.$emit("busShowPageUser", true);
        }
      },

      manageDeviceFolderSave: function(evt) {
        evt.srcElement.disabled = "disabled"
        this.showManageDeviceFolderSpinner = true

        this.storeSaveFolder()
        .then(() => {
          evt.srcElement.disabled = ""
          this.showManageDeviceFolderSpinner = false
          this.makeToast("success", this.$t("tHeader.saveFoldersSuccess"), this.$t("tHeader.saveFoldersSuccessBody"))
          this.hideModal("manageDeviceFolderFloat")
        })
        .catch(error => {
          evt.srcElement.disabled = ""
          this.showManageFriendsSpinner = false
          this.makeToast("danger", this.$t("tHeader.saveFriendsListFailure"), this.$t("tHeader.saveFriendsListFailureBody", { "detailed" : error}))
        })
      },

      manageDeviceFolderAddFolder: function() {
        if(!this.$refs.newFolderForm.checkValidity()) {
          this.$refs.newFolderForm.reportValidity();
          return false;
        }
        this.loginUser.folders.push(this.newDeviceFolderName);
        this.newDeviceFolderName = "";
      },

      manageDeviceFolderUpDevice: function(folderName, deviceId) {
        let tempIndex = this.loginUser.foldersInfo[deviceId].index;
        if(tempIndex != 0) {
          for(let deviceItem in this.loginUser.foldersInfo) {
            if(this.loginUser.foldersInfo[deviceItem].folder == folderName && this.loginUser.foldersInfo[deviceItem].index == (tempIndex-1)) {
              // this.$set(this.loginUser.foldersInfo[deviceId], "index", this.loginUser.foldersInfo[deviceItem].index);
              // this.$set(this.loginUser.foldersInfo[deviceItem], "index", tempIndex);

              this.loginUser.foldersInfo[deviceId].index = this.loginUser.foldersInfo[deviceItem].index;
              this.loginUser.foldersInfo[deviceItem].index = tempIndex;
              break;
            }
          }
        }
      },

      manageDeviceFolderDownDevice: function(folderName, deviceId) {
        let tempIndex = this.loginUser.foldersInfo[deviceId].index;
        for(let deviceItem in this.loginUser.foldersInfo) {
          if(this.loginUser.foldersInfo[deviceItem].folder == folderName && this.loginUser.foldersInfo[deviceItem].index == (tempIndex+1)) {
            // this.$set(this.loginUser.foldersInfo[deviceId], "index", this.loginUser.foldersInfo[deviceItem].index);
            // this.$set(this.loginUser.foldersInfo[deviceItem], "index", tempIndex);
            this.loginUser.foldersInfo[deviceId].index = this.loginUser.foldersInfo[deviceItem].index;
            this.loginUser.foldersInfo[deviceItem].index = tempIndex;
            break;
          }
        }
      },

      manageDeviceFolderMoveDevice: function(folderName, deviceId, targetFolder) {
        this.$set(this.loginUser.foldersInfo[deviceId], "index", 1000);
        this.$set(this.loginUser.foldersInfo[deviceId], "folder", targetFolder);
        this.resetFoldersInfoFolderIndex(folderName);
        this.resetFoldersInfoFolderIndex(targetFolder);
      },

      manageDeviceFolderRenameFolder: function(folderName) {

        let newFolderName = window.document.getElementById("folderInput_" + folderName).value;

        for(let deviceId in this.loginUser.foldersInfo) {
          if(this.loginUser.foldersInfo[deviceId].folder == folderName) {
            this.$set(this.loginUser.foldersInfo[deviceId], "folder", newFolderName);
          }
        }

        for(let i=0;i<this.loginUser.folders.length;i++) {
          if(this.loginUser.folders[i] == folderName) {
            this.loginUser.folders.splice(i, 1, newFolderName);
            break;
          }
        }
      },

      manageDeviceFolderRemoveFolder: function(folderName) {
        let newIndex = 1000;
        for(let deviceId in this.loginUser.foldersInfo) {
          if(this.loginUser.foldersInfo[deviceId].folder == folderName) {
            this.$set(this.loginUser.foldersInfo[deviceId], "folder", "@root");
            this.$set(this.loginUser.foldersInfo[deviceId], "index", newIndex++);
          }
        }
        this.resetFoldersInfoFolderIndex(folderName);
        for(let i=0;i<this.loginUser.folders.length;i++) {
          if(this.loginUser.folders[i] == folderName) {
            this.loginUser.folders.splice(i, 1);
            break;
          }
        }
      },

      manageFriendsAddFriendByObject: function(user) {
        if(!this.loginUser.frApp.some(item=>{ return item == user.id })) {
          if(this.loginUser.id != user.id) {
            this.loginUser.frApp.push(user.id);
            if(typeof(this.loginUser.frAppCache[user.id]) == "undefined") {
              this.loginUser.frAppCache[user.id] = {};
            }
            if(typeof(user.email) != "undefined") {
              this.loginUser.frAppCache[user.id].email = user.email;
            }
            if(typeof(user.displayName) != "undefined") {
              this.loginUser.frAppCache[user.id].displayName = user.displayName;
            }
          }
          else {
            this.makeToast("danger", this.$t("tHeader.failToAddFriend"), this.$t("tHeader.canNotAddMySelf"));
          }
        }
        else {
          this.makeToast("danger", this.$t("tHeader.failToAddFriend"), this.$t("tHeader.alreadyAddedAsFriend"));
        }
      },
      manageFriendsAddFriend: function() {
        if(!window.document.getElementById('newFriendIdForm').checkValidity()) {
          window.document.getElementById('newFriendIdForm').reportValidity();
          return false;
        }

        this.requestDisabled = true;
        if(!this.loginUser.frApp.some(item=>{ return item == this.newFriendId })) {

          this.getWithAuth(this.functionsServer + "/app/isExistUid?uid=" + this.newFriendId)
          .then(result=> {
            if(result.status != 200) {
              this.makeToast("danger", this.$t("tHeader.failToAddFriend"), this.$t("common.serverError", {
                status: result.status,
                statusText: result.statusText
              }));
            }
            else {
              if(result.data.success) {
                if(typeof(result.data.uid) != "undefined") {

                  if(!this.loginUser.frApp.some(item=>{ return item == result.data.uid })) {
                    if(this.loginUser.id != result.data.uid) {
                      this.loginUser.frApp.push(result.data.uid);
                      if(typeof(this.loginUser.frAppCache[result.data.uid]) == "undefined") {
                        this.loginUser.frAppCache[result.data.uid] = {};
                      }
                      if(typeof(result.data.email) != "undefined") {
                        this.loginUser.frAppCache[result.data.uid].email = result.data.email;
                      }
                      if(typeof(result.data.displayName) != "undefined") {
                        this.loginUser.frAppCache[result.data.uid].displayName = result.data.displayName;
                      }
                      this.newFriendId = "";
                    }
                    else {
                      this.makeToast("danger", this.$t("tHeader.failToAddFriend"), this.$t("tHeader.canNotAddMySelf"));
                    }
                  }
                  else {
                    this.makeToast("danger", this.$t("tHeader.failToAddFriend"), this.$t("tHeader.alreadyAddedAsFriend"));
                  }
                }
                else {
                  this.makeToast("danger", this.$t("tHeader.failToAddFriend"), this.$t("tHeader.noIdInResponse"));
                }
              }
              else {
                if(result.data.error == 1) {
                  this.makeToast("danger", this.$t("tHeader.failToAddFriend"), this.$t("common.errorInServer"));
                }
                else if(result.data.error == 2) {
                  this.makeToast("danger", this.$t("tHeader.failToAddFriend"), this.$t("common.noUserWithThatInfo"));
                }
                else if(result.data.error == 3) {
                  this.makeToast("danger", this.$t("tHeader.failToAddFriend"), this.$t("tHeader.duplicatedEmailUser"));
                }
              }
            }
          })
          .catch(error => {
            this.makeToast("danger", this.$t("tHeader.failToAddFriend"), this.$t("tHeader.notSendFriendRequestError", { "detailed": error }));
            window.setTimeout(()=> {
              this.requestDisabled = false;
            }, 5000);
          });
        }
        else {
          this.makeToast("danger", this.$t("tHeader.failToAddFriend"), this.$t("tHeader.alreadyFriendError"));
        }
        window.setTimeout(()=> {
          this.requestDisabled = false;
        }, 5000);
      },
      manageFriendsRemoveFriend: function(friend, index) {
        this.$delete(this.loginUser.frApp, index);
        if(typeof(this.loginUser.frAppCache[friend]) != "undefined") {
          this.$delete(this.loginUser.frAppCache, friend);
        }
      },
      manageFriendsReqMove2Friend: function(friend) {
        if(!this.loginUser.frApp.some(item=>{ return item == friend })) {
          this.loginUser.frApp.push(friend);
          this.$set(this.loginUser.frAppCache, friend, this.loginUser.frReq[friend]);
          this.$delete(this.loginUser.frReq, friend);
        }
        else {
          this.makeToast("danger", this.$t("tHeader.failToAddFriend"), this.$t("tHeader.alreadyFriendRemoveRequestedError"));
        }
      },
      manageFriendsReqRemoveFriend: function(friend) {
        if(typeof(this.loginUser.frReq[friend]) != "undefined") {
          this.$delete(this.loginUser.frReq, friend);
        }
      },
      manageFriendsSave: function(evt) {
        evt.srcElement.disabled = "disabled"
        this.showManageFriendsSpinner = true

        this.storeSaveFriends()
        .then(() => {
          evt.srcElement.disabled = ""
          this.showManageFriendsSpinner = false
          this.makeToast("success", this.$t("tHeader.saveFriendsListSuccess"), this.$t("tHeader.saveFriendsListSuccessBody"))
          this.hideModal("manageFriendsFloat")
        })
        .catch(error => {
          evt.srcElement.disabled = ""
          this.showManageFriendsSpinner = false
          this.makeToast("danger", this.$t("tHeader.saveFriendsListFailure"), this.$t("tHeader.saveFriendsListFailureBody", { "detailed" : error}))
        })
      },

      manageBookmarkRemoveFolder: function(index) {
        if(this.loginUser.bookmarks.length > 1) {
          this.$delete(this.loginUser.bookmarks, index);
        }
        else {
          this.makeToast("danger", this.$t("tHeader.deleteBookmarkFail"), this.$t("tHeader.deleteBookmarkFailBody"))
        }
      },
      manageBookmarkAddHere: function(listIndex) {
        this.loginUser.bookmarks[listIndex].list.push(this.newBookmarkObject);
        this.newBookmarkObject = null;
        this.$root.$emit('bv::toggle::collapse', 'bookmarkList_' + listIndex)
      },
      manageBookmarkAddCancel: function() {
          this.newBookmarkObject = null;
      },
      manageBookmarkAddBookmarkByObject: function(obj) {
          this.newBookmarkObject = obj;
      },
      manageBookmarkAddFolder: function() {

        if(!this.loginUser.bookmarks.some(item=>{ return item.name == this.newBookmarkFolderName })) {
          this.loginUser.bookmarks.push({
            "name": this.newBookmarkFolderName,
            "list": []
          });
        }
        else {
          this.makeToast("danger", this.$t("tHeader.addBookmarkFolderFailed"), this.$t("tHeader.duplicatedFolderName"));
        }
      },
      manageBookmarkMoveBookmark: function(listIndex, index, pos) {
        this.loginUser.bookmarks[pos].list.push(this.loginUser.bookmarks[listIndex].list[index]);
        this.$delete(this.loginUser.bookmarks[listIndex].list, index);
        this.$root.$emit('bv::toggle::collapse', 'bookmarkList_' + pos);
      },
      manageBookmarkRemoveBookmark: function(listIndex, index) {
        this.$delete(this.loginUser.bookmarks[listIndex].list, index);
      },
      manageBookmarkSave: function(evt) {

        evt.srcElement.disabled = "disabled"
        this.showManageBookmarkSpinner = true

        this.storeSaveBookmark()
        .then(() => {
          evt.srcElement.disabled = ""
          this.showManageBookmarkSpinner = false
          this.makeToast("success", this.$t("tHeader.saveBookmarkSuccess"), this.$t("tHeader.saveBookmarkSuccessBody"))
          this.hideModal("manageBookmarkFloat")
        })
        .catch(error => {
          evt.srcElement.disabled = ""
          this.showManageBookmarkSpinner = false
          this.makeToast("danger", this.$t("tHeader.saveBookmarkFailure") , this.$t("tHeader.saveBookmarkFailureBody", { "detailed" : error}))
        })

      },
      changeLang: function(lang) {
        if(typeof(lang) != "undefined" && this.selectedLang != lang) {
          this.selectedLang = lang;
          this.$i18n.locale = lang;
          this.$cookies.set('lang',JSON.stringify(lang));
          eventBus.$emit("changeLang", lang);
        }
      },
      enterPresentation: function() {
        this.presentationMode = true
      },
      loginFloatKey: function(evt) {
        evt.srcElement.click()
      },
      userMenuKey: function(evt) {
        evt.srcElement.click()
      },
      busSendConfirmMail: function() {
         eventBus.$emit('busSendConfirmMail')
      },
      busUserFloatLogout: function() {
         eventBus.$emit('busUserFloatLogout')
      },
      applyPhotoURL: function(evt) {
        this.loginUser.photoURL = evt.srcElement.dataset.photourl
        this.generatedIcon = "https://robohash.org/" + Math.floor(Math.random() * 1000000)
      },
      applyDisplayName: function(evt) {
        this.loginUser.displayName = evt.srcElement.dataset.displayname
      },
      sendConfirmMail: function() {
        if(!this.$store.state.loginUser.emailVerified) {
          this.currentUser.sendEmailVerification().then(() => {
            this.makeToast("success", this.$t("tHeader.SentConfirmEmail"), this.$t("tHeader.SentConfirmEmailBody"))
          }).catch(() => {
            this.makeToast("danger", this.$t("tHeader.FailToSendConfirmEmail"), this.$t("tHeader.FailToSendConfirmEmailBody"))
          })
          this.emailVerifiedChecker = window.setInterval(() => {
            if(this.currentUser != null) {
              this.currentUser.reload()
              if(this.currentUser.emailVerified) {
                this.loginUser.emailVerified = true
                this.emailVerifiedCheckerCount = 0
                this.storeSaveLoginUserEmailVerified()
                window.clearInterval(this.emailVerifiedChecker)
              }
              this.emailVerifiedCheckerCount++
              if(this.emailVerifiedCheckerCount > 100) {
                window.clearInterval(this.emailVerifiedChecker)
              }
            }
            else {
              window.clearInterval(this.emailVerifiedChecker)
            }
          }, 3000)
        }
      },
      logout: function() {
        this.updatePasswordCurrentPassword = ""
        this.updatePasswordNewPassword = ""

        firebase.auth().signOut().then(()=>{
          this.isNewUser = false
          this.providerId = null
          this.currentUser = null
          this.loginUser = null
          this.loginUserBinded = false
          this.notLoginConfirmed = false

          this.storeUnbindingLoginUserRef().then(()=>{
            window.localStorage.setItem('isNewUser', false)
            window.localStorage.setItem('providerId', null)
            this.authUi.reset()
            this.authUi.start("#loginFloatBody", firebaseUiConfig)
          }).catch((error) => {
            this.makeToast("danger", this.$t("common.logoutFail"), this.$t("common.errorDetailed") + error.message)
          })
        }).catch((error) => {
          this.makeToast("danger", this.$t("common.logoutFail"), this.$t("common.errorDetailed") + error.message)
        })
      },

      userProfileSave: function(evt) {

        if(this.$store.state.loginUser.emailVerified) {
          if(!window.document.getElementById('editProfileDisplayName').checkValidity()) {
            window.document.getElementById('editProfileDisplayName').reportValidity()
            return false
          }
          if(!window.document.getElementById('editProfilePhotoURL').checkValidity()) {
            window.document.getElementById('editProfilePhotoURL').reportValidity()
            return false
          }
          evt.srcElement.disabled = "disabled"
          this.showUpdateUserProfileSpinner = true

          let oldDeepBinding = this.loginUserDeepBinding;

          this.currentUser.updateProfile({
            displayName: this.loginUser.displayName,
            description: this.loginUser.description,
            photoURL: this.loginUser.photoURL,
          }).then(() => {
            this.storeSaveLoginUserProfile()
            .then(() => {
              this.showUpdateUserProfileSpinner = false
              this.hideModal("editProfileFloat")
              evt.srcElement.disabled = ""
              if(oldDeepBinding != this.loginUser.deepBinding) {
                this.$router.push("/?now=" + (new Date()).getTime());
              }
              this.makeToast("success", this.$t("tHeader.userProfileUpdateSuccess"), this.$t("common.updateSuccess"))
            })
            .catch(error => {
              evt.srcElement.disabled = ""
              this.showUpdateUserProfileSpinner = false
              this.$log.debug("tUserFloat userProfileSave error3");
              this.makeToast("danger", this.$t("tHeader.userProfileUpdateFail"), this.$t("common.errorDetailed") + error)
            })
          })
          .catch(error => {
            evt.srcElement.disabled = ""
            this.showUpdateUserProfileSpinner = false
            this.$log.debug("tUserFloat userProfileSave error3");
            this.makeToast("danger", this.$t("tHeader.userProfileUpdateFail"), this.$t("common.errorDetailed") + error)
          })
        }
      },
      updatePassword: function(evt) {
        if(this.loginUser.emailVerified) {
          if(this.providerId == "password") {
            if(!window.document.getElementById('updatePasswordCurrentPassword').checkValidity()) {
              window.document.getElementById('updatePasswordCurrentPassword').reportValidity()
              return false
            }
            if(!window.document.getElementById('updatePasswordNewPassword').checkValidity()) {
              window.document.getElementById('updatePasswordNewPassword').reportValidity()
              return false
            }
            evt.srcElement.disabled = "disabled"
            this.showUpdatePasswordSpinner = true
            firebase.auth().signInWithEmailAndPassword(this.$store.state.loginUser.email, this.updatePasswordCurrentPassword)
            .then(() => {
              this.currentUser.updatePassword(this.updatePasswordNewPassword)
              .then(() => {
                this.makeToast("success", this.$t("tHeader.changePasswordSuccess"), this.$t("tHeader.changePasswordSuccessBody"))
                this.hideModal("updatePasswordFloat")
                this.updatePasswordFloatShow = false
                this.updatePasswordCurrentPassword = ""
                this.updatePasswordNewPassword = ""
                evt.srcElement.disabled = ""
                this.showUpdatePasswordSpinner = false
              })
              .catch((error) => {
                this.makeToast("danger", this.$t("tHeader.changePasswordFail"), this.$t("common.errorDetailed") + error.message)
                this.updatePasswordFloatShow = false
                evt.srcElement.disabled = ""
                this.showUpdatePasswordSpinner = false
              })
            })
            .catch((error) => {
              this.makeToast("danger", this.$t("tHeader.changePasswordFail"), this.$t("common.errorDetailed") + error.message + error.message)
              this.updatePasswordFloatShow = false
              evt.srcElement.disabled = ""
              this.showUpdatePasswordSpinner = false
            })
          }
          else if(this.providerId == "google.com") {
            if(!window.document.getElementById('updatePasswordNewPassword').checkValidity()) {
              window.document.getElementById('updatePasswordNewPassword').reportValidity()
              return false
            }
            evt.srcElement.disabled = "disabled"
            this.showUpdatePasswordSpinner = false
            var provider = new firebase.auth.GoogleAuthProvider()
            firebase.auth().signInWithPopup(provider)
            .then((result) => {
              if(result.user.email != this.loginUser.email) {
                throw new Error(this.$log("tUserFloat.notCurrentLoginUserMessage"));
              }
              else {
                this.currentUser.updatePassword(this.updatePasswordNewPassword)
                .then(() => {
                  this.makeToast("success", this.$t("tHeader.changePasswordSuccess"), this.$t("tHeader.changePasswordSuccessBody"))
                  this.hideModal("updatePasswordFloat")
                  this.updatePasswordFloatShow = false
                  this.updatePasswordCurrentPassword = ""
                  this.updatePasswordNewPassword = ""
                  evt.srcElement.disabled = "disabled"
                  this.showUpdatePasswordSpinner = false
                })
                .catch((error) => {
                  this.makeToast("danger", this.$t("tHeader.changePasswordFail"), this.$t("common.errorDetailed") + error.message)
                  this.updatePasswordFloatShow = false
                  evt.srcElement.disabled = "disabled"
                  this.showUpdatePasswordSpinner = false
                })
              }
            })
            .catch((error) => {
              this.makeToast("danger", this.$t("tHeader.changePasswordFail"), this.$t("common.errorDetailed") + error.message)
              this.updatePasswordFloatShow = false
              evt.srcElement.disabled = "disabled"
              this.showUpdatePasswordSpinner = false
            })
          }
        }
      },
      updateEmailAddress: function(evt) {
        if(this.$store.state.loginUser.emailVerified) {
          if(this.providerId == "password") {
            if(!window.document.getElementById('changeEmailAddressPassword').checkValidity()) {
              window.document.getElementById('changeEmailAddressPassword').reportValidity()
              return false
            }
            if(!window.document.getElementById('changeEmailAddressNewEmailAddress').checkValidity()) {
              window.document.getElementById('changeEmailAddressNewEmailAddress').reportValidity()
              return false
            }
            evt.srcElement.disabled = "disabled"
            this.showUpdateEmailAddressSpinner = true

            firebase.auth().signInWithEmailAndPassword(this.$store.state.loginUser.email, this.changeEmailAddressPassword)
            .then(() => {
              this.currentUser.updateEmail(this.changeEmailAddressNewEmailAddress)
              .then(() => {
                this.$store.state.loginUser.email = this.changeEmailAddressNewEmailAddress
                this.$store.state.loginUser.emailVerified = false
                this.storeSaveLoginUserEmail()
                .then(()=>{
                  this.currentUser.sendEmailVerification()
                  this.makeToast("success", this.$t("tHeader.changeEmailAddressSuccess"), this.$t("tHeader.changeEmailAddressSuccessBody"))
                  this.hideModal("changeEmailAddressFloat")
                  this.changeEmailAddressFloatShow = false;
                  this.changeEmailAddressNewEmailAddress = ""
                  this.changeEmailAddressPassword = ""
                  evt.srcElement.disabled = ""
                  this.showUpdateEmailAddressSpinner = false
                })
                .catch((error) => {
                  this.makeToast("danger", this.$t("tHeader.changeEmailAddressFail"), this.$t("common.errorDetailed") + error.message)
                  this.updatePasswordFloatShow = false
                  evt.srcElement.disabled = ""
                  this.showUpdateEmailAddressSpinner = false
                })
              })
              .catch((error) => {
                this.makeToast("danger", this.$t("tHeader.changeEmailAddressFail"), this.$t("common.errorDetailed") + error.message)
                this.updatePasswordFloatShow = false
                evt.srcElement.disabled = ""
                this.showUpdateEmailAddressSpinner = false
              })
            })
            .catch((error) => {
              this.makeToast("danger", this.$t("tHeader.changeEmailAddressFail"), this.$t("common.errorDetailed") + error.message)
              this.updatePasswordFloatShow = false
              evt.srcElement.disabled = ""
              this.showUpdateEmailAddressSpinner = false
            })
          }
          else if(this.providerId == "google.com") {
            if(!window.document.getElementById('changeEmailAddressNewEmailAddress').checkValidity()) {
              window.document.getElementById('changeEmailAddressNewEmailAddress').reportValidity()
              return false
            }
            evt.srcElement.disabled = "disabled"
            this.showUpdateEmailAddressSpinner = true
            var provider = new firebase.auth.GoogleAuthProvider()
            firebase.auth().signInWithPopup(provider)
            .then((result) => {
              if(result.user.email != this.loginUser.email) {
                throw new Error(this.$t("tHeader.notCurrentLoginUserMessage"));
              }
              else {
                this.currentUser.updateEmail(this.changeEmailAddressNewEmailAddress)
                .then(() => {
                  this.$store.state.loginUser.email = this.changeEmailAddressNewEmailAddress
                  this.$store.state.loginUser.emailVerified = false
                  this.storeSaveLoginUserEmail()
                  this.currentUser.sendEmailVerification()
                  this.makeToast("success", this.$t("changeEmailAddressSuccess"), this.$t("changeEmailAddressSuccessBody"))
                  this.hideModal("changeEmailAddressFloat")
                  this.changeEmailAddressFloatShow = false
                  this.changeEmailAddressNewEmailAddress = ""
                  this.changeEmailAddressPassword = ""
                  evt.srcElement.disabled = ""
                  this.showUpdateEmailAddressSpinner = false
                })
                .catch((error) => {
                  this.makeToast("danger", this.$t("tHeader.changeEmailAddressFail"), this.$t("common.errorDetailed") + error.message)
                  this.updatePasswordFloatShow = false
                  evt.srcElement.disabled = ""
                  this.showUpdateEmailAddressSpinner = false
                })
              }
            })
            .catch((error) => {
              this.makeToast("danger", this.$t("tHeader.changeEmailAddressFail"), this.$t("common.errorDetailed") + error.message)
              this.updatePasswordFloatShow = false
              evt.srcElement.disabled = ""
              this.showUpdateEmailAddressSpinner = false
            })
          }
        }
      },
      ...mapActions(['storeSaveFolder', 'storeBindingLoginUserRef', 'storeUnbindingLoginUserRef', 'storeSaveLoginUserProfile', 'storeSaveLoginUserEmailVerified', 'storeSaveLoginUserEmail', 'storeSaveFriends', 'storeSaveBookmark']),
    },
    computed: {
      ...mapSetter(
        mapState({
          currentUser: state => state.currentUser,
          providerId: state => state.providerId,
          isNewUser: state => state.isNewUser,
          loginUserDeepBinding: state => state.loginUserDeepBinding,
          // editProfileFloatShow:  state => state.editProfileFloatShow,
          // updatePasswordFloatShow:  state => state.updatePasswordFloatShow,
          // changeEmailAddressFloatShow:  state => state.changeEmailAddressFloatShow
        })
      )
    },
  }
</script>
<style scoped>
  #myPhoto:focus {
    outline: none;
  }
  #myPhotoBig {
    width: 4.2rem; height: 4.2rem;
  }
  .myMedia .media-aside { margin-right: 0.5rem; }


</style>
